module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "grid addhotel"
  }, [_c('el-tooltip', {
    staticClass: "item back",
    attrs: {
      "effect": "dark",
      "content": "torna in spiaggia",
      "placement": "left-start"
    }
  }, [_c('el-button', [_c('router-link', {
    attrs: {
      "to": {
        path: '/hotel'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-umbrella-beach"
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grid generator"
  }, [_c('div', {
    staticClass: "grid steps"
  }, [_c('div', {
    staticStyle: {
      "width": "auto",
      "min-width": "960px"
    }
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.grid.active,
      "align-center": "",
      "finish-status": "success"
    }
  }, _vm._l((_vm.filteredSteps), function(option, index) {
    return _c('el-step', {
      key: index,
      attrs: {
        "title": option.title,
        "description": option.desc
      },
      nativeOn: {
        "click": function($event) {
          return (function (e) { return _vm.stepHandler(e, index); })($event)
        }
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid cont"
  }, [(_vm.grid.active === 0) ? _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "one"
    }
  }, [(!_vm.loading) ? _c('h2', [_vm._v("Aggiungi il tuo Hotel")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', {
    ref: "formAddhotel",
    attrs: {
      "model": _vm.hotel,
      "rules": _vm.rules,
      "status-icon": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "Nome Hotel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nome Hotel",
      "type": "text"
    },
    model: {
      value: (_vm.hotel.name),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "name", $$v)
      },
      expression: "hotel.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "",
      "label": "Colore preferito"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.hotel.colors.primary),
      callback: function($$v) {
        _vm.$set(_vm.hotel.colors, "primary", $$v)
      },
      expression: "hotel.colors.primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-button-group', [(_vm.grid.active !== 0) ? _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button",
      "icon": "el-icon-arrow-left"
    }
  }, [_vm._v("Indietro")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.next('formAddhotel')
      }
    }
  }, [_vm._v("Avanti "), _c('i', {
    staticClass: "el-icon-arrow-right el-icon-right"
  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.grid.active === 1) ? _c('div', {
    attrs: {
      "id": "two"
    }
  }, [_c('h2', [_vm._v("Scegli il modello di spiaggia")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', {
    ref: "formAddhotel",
    attrs: {
      "model": _vm.hotel,
      "inline": true,
      "rules": _vm.rules,
      "status-icon": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "grid",
      "border": ""
    },
    model: {
      value: (_vm.hotel.beachtype),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "beachtype", $$v)
      },
      expression: "hotel.beachtype"
    }
  }, [_vm._v("Spiaggia con righe e colonne fisse "), _c('img', {
    attrs: {
      "src": "/static/img/addhotel-grid.png"
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "canvas",
      "border": ""
    },
    model: {
      value: (_vm.hotel.beachtype),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "beachtype", $$v)
      },
      expression: "hotel.beachtype"
    }
  }, [_vm._v("Spiaggia libera, imposto gli ombrelloni da solo "), _c('img', {
    attrs: {
      "src": "/static/img/addhotel-canvas.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-button-group', [(_vm.grid.active !== 0) ? _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        _vm.grid.active--
      }
    }
  }, [_vm._v("Indietro")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changeStep
    }
  }, [_vm._v("Avanti "), _c('i', {
    staticClass: "el-icon-arrow-right el-icon-right"
  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.grid.active === 2) ? _c('div', {
    attrs: {
      "id": "three"
    }
  }, [_c('h3', [_vm._v("Inserisci/cambia la lettera e il numero del primo ombrellone in fronte mare a sinistra")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid",
    staticStyle: {
      "grid-auto-flow": "column",
      "justify-content": "space-between"
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "rules": _vm.rules,
      "model": _vm.hotel
    }
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("Righe in Spiaggia")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "rows"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.hotel.rows),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "rows", $$v)
      },
      expression: "hotel.rows"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("Colonne in Spiaggia")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "cols"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.hotel.cols),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "cols", $$v)
      },
      expression: "hotel.cols"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lettera",
      "prop": "letterfirst"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "prima lettera"
    },
    model: {
      value: (_vm.letters.first),
      callback: function($$v) {
        _vm.$set(_vm.letters, "first", $$v)
      },
      expression: "letters.first"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Numero",
      "prop": "numberfirst"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "primo numero"
    },
    model: {
      value: (_vm.numbers.first),
      callback: function($$v) {
        _vm.$set(_vm.numbers, "first", $$v)
      },
      expression: "numbers.first"
    }
  })], 1), _vm._v(" "), _c('el-button-group', [(_vm.grid.active !== 0) ? _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        _vm.grid.active--
      }
    }
  }, [_vm._v("Indietro")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetGrid
    }
  }, [_vm._v("Avanti "), _c('i', {
    staticClass: "el-icon-arrow-right el-icon-right"
  })])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grid step first"
  }, [_c('div', {
    staticClass: "grid ombrello",
    staticStyle: {
      "grid-template-columns": "1fr 1fr 1fr",
      "grid-row-gap": "12px",
      "grid-column-gap": "12px"
    }
  }, [_c('div', {
    staticClass: "blocco seat free first"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.letters.first) + _vm._s(_vm.numbers.first))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])])])]) : _vm._e(), _vm._v(" "), (_vm.grid.active === 3) ? _c('div', {
    attrs: {
      "id": "four"
    }
  }, [_c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), (_vm.hotel.beachtype === 'grid') ? _c('div', [_c('h2', [_vm._v("Controlla e salve")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', {
    ref: "formAddhotel",
    attrs: {
      "model": _vm.hotel,
      "inline": true,
      "rules": _vm.rules,
      "status-icon": ""
    }
  }, [(_vm.letters.first.length !== 0) ? _c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "left",
      "border": ""
    },
    on: {
      "change": _vm.resetGrid
    },
    model: {
      value: (_vm.hotel.gridtype),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "gridtype", $$v)
      },
      expression: "hotel.gridtype"
    }
  }, [_c('div', {
    staticClass: "grid ombrello",
    staticStyle: {
      "grid-template-columns": "1fr 1fr",
      "grid-row-gap": "12px",
      "grid-column-gap": "12px"
    }
  }, [_c('div', {
    staticClass: "blocco seat free first"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.first.letter) + _vm._s(_vm.pregrid.first.number))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.left.letter) + _vm._s(_vm.pregrid.left.number))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.up.letter) + _vm._s(_vm.pregrid.up.number))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.upleft.letter) + _vm._s(_vm.pregrid.upleft.number))])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.letters.first.length !== 0) ? _c('el-form-item', {
    attrs: {
      "prop": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "up",
      "border": ""
    },
    on: {
      "change": _vm.resetGrid
    },
    model: {
      value: (_vm.hotel.gridtype),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "gridtype", $$v)
      },
      expression: "hotel.gridtype"
    }
  }, [_c('div', {
    staticClass: "grid ombrello",
    staticStyle: {
      "grid-template-columns": "1fr 1fr",
      "grid-row-gap": "12px",
      "grid-column-gap": "12px"
    }
  }, [_c('div', {
    staticClass: "blocco seat free first"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.first.letter) + _vm._s(_vm.pregrid.first.number))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.up.letter) + _vm._s(_vm.pregrid.up.number))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.left.letter) + _vm._s(_vm.pregrid.left.number))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.upleft.letter) + _vm._s(_vm.pregrid.upleft.number))])])])])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "empty",
      "border": ""
    },
    on: {
      "change": _vm.resetGrid
    },
    model: {
      value: (_vm.hotel.gridtype),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "gridtype", $$v)
      },
      expression: "hotel.gridtype"
    }
  }, [_c('div', {
    staticClass: "grid ombrello",
    staticStyle: {
      "grid-template-columns": "1fr 1fr",
      "grid-row-gap": "12px",
      "grid-column-gap": "12px"
    }
  }, [_c('div', {
    staticClass: "blocco seat free first"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(Number(_vm.numbers.first)))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(Number(_vm.numbers.first) + 1))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(Number(_vm.numbers.first) + _vm.hotel.cols))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s((Number(_vm.numbers.first) + 1) + _vm.hotel.cols))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-button-group', [(_vm.grid.active !== 0) ? _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        _vm.grid.active--
      }
    }
  }, [_vm._v("Indietro")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveGrid
    }
  }, [_vm._v("Salva Impostazioni "), _c('i', {
    staticClass: "el-icon-arrow-right el-icon-right"
  })])], 1)], 1)], 1) : _c('div', {
    staticClass: "guide"
  }, [_c('h2', [_vm._v("Sei pronto a partire")]), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('el-button-group', [(_vm.grid.active !== 0) ? _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        _vm.grid.active--
      }
    }
  }, [_vm._v("Indietro")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveGrid
    }
  }, [_vm._v("Ok "), _c('i', {
    staticClass: "el-icon-arrow-right el-icon-right"
  })])], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "grid",
    staticStyle: {
      "padding": "96px 0",
      "max-width": "1200px"
    },
    style: (_vm.style)
  }, _vm._l((_vm.ombrelli), function(ombrello, index) {
    return _c('div', {
      staticClass: "grid ombrello drag"
    }, [(!ombrello.free) ? _c('div', {
      staticClass: "grid seat",
      class: {
        minimal: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds
      },
      style: ({
        background: _vm.hotel.colors.secondary
      }),
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_c('div', {
      staticClass: "grid header",
      class: {
        single: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds, hidden: !_vm.hotel.poolsettings.chairs && !_vm.hotel.poolsettings.beds
      }
    }, [(_vm.hotel.poolsettings.beds) ? _c('img', {
      attrs: {
        "src": require("../assets/img/beach-deckchair-.png")
      }
    }) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.chairs) ? _c('img', {
      attrs: {
        "src": require("../assets/img/beach-chair.png")
      }
    }) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.chairs) ? _c('span', {
      staticClass: "grid"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removechair(index, ombrello.chairs, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(ombrello.chairs)), _c('a', {
      on: {
        "click": function($event) {
          return _vm.addchair(index, ombrello.chairs, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])]) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.beds) ? _c('span', {
      staticClass: "grid"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removebed(index, ombrello.beds, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(ombrello.beds)), _c('a', {
      on: {
        "click": function($event) {
          return _vm.addbed(index, ombrello.beds, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])]) : _vm._e()]), _vm._v(" "), (!_vm.hotel.poolsettings.guest && !_vm.hotel.poolsettings.room) ? _c('el-popover', {
      attrs: {
        "placement": "top-start",
        "title": ombrello.guestsinday[0].room,
        "width": "200",
        "trigger": "hover",
        "content": ombrello.guestsinday[0].name
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fas fa-info-circle"
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.room || _vm.hotel.poolsettings.guest) ? _c('div', {
      staticClass: "grid ident"
    }, [(_vm.hotel.poolsettings.room) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.guestsinday[0].room))]) : _vm._e(), _vm._v(" "), (ombrello.guest && _vm.hotel.poolsettings.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guestsinday[0].name))]) : _vm._e(), _vm._v(" "), (!ombrello.guest && _vm.hotel.poolsettings.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v("no guest name")]) : _vm._e(), _vm._v(" "), (ombrello.guestsinday.length > 1) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.guestsinday[1].room))]) : _vm._e(), _vm._v(" "), (ombrello.guest && ombrello.guestsinday.length > 1) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guestsinday[1].name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid data",
      class: {
        minimal: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds, hidden: !_vm.hotel.poolsettings.arrival
      }
    }, [_c('div', {
      staticClass: "grid nr"
    }, [_vm._v(_vm._s(ombrello.ombrid))]), _vm._v(" "), (_vm.hotel.poolsettings.arrival || _vm.hotel.poolsettings.departure) ? _c('div', {
      staticClass: "grid date",
      class: {
        hidden: !_vm.hotel.poolsettings.arrival
      }
    }, [_c('span', [_c('span', {
      staticClass: "fa fa-chevron-right"
    }), _vm._v(" " + _vm._s(ombrello.arrival))]), _vm._v(" "), _c('span', [_c('span', {
      staticClass: "fa fa-chevron-left"
    }), _vm._v(" " + _vm._s(ombrello.departure))])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (ombrello.free) ? _c('div', {
      staticClass: "blocco seat free",
      attrs: {
        "id": ombrello._id
      }
    }, [_c('a', {
      staticClass: "blocco nr",
      attrs: {
        "id": ombrello._id
      },
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.ombrid))])]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  })]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('circle4') : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Nella prossima schermata troverai una spiaggia libera, clicca su questa icona "), _c('i', {
    staticClass: "fas fa-wrench"
  }), _vm._v(" nel menu a sinistra per aggiungere o spostare gli ombrelloni.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Usa questo "), _c('i', {
    staticClass: "fas fa-umbrella-beach"
  }), _vm._v(" per aggiungere gli ombrelloni o clicca e trascina gli ombrelloni gia inseriti per spostarli.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c4de4fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Addhotel.vue
// module id = 631
// module chunks = 1